<template>
  <OptionalValidationWrapper
    :clickPrevent="false"
    :errorStyleExceptions="$style.hideErrors"
    :label="label"
    :tooltip="tooltip"
  >
    <div :class="$style.content">
      <slot />
    </div>
  </OptionalValidationWrapper>
</template>
<script>
import OptionalValidationWrapper from 'components/FormValidation/OptionalValidationWrapper.vue';
import TooltipPropMixin from 'components/FormValidation/mixins/TooltipPropMixin';

/**
 * This component displays an optional validation wrapper with the specified header and tooltip and
 * then displays its slot content indented under the label. It it used to group common input rows,
 * slightly indented, under a single label.
 */
export default {
  name: 'ChildForm',

  inject: ['$validator'],

  components: {
    OptionalValidationWrapper,
  },

  mixins: [
    TooltipPropMixin,
  ],

  props: {
    label: {
      type: String,
      default: '',
    },
  },
};
</script>
<style module>
.content {
  margin-left: 22px;
  margin-top: 11px;
}

.hideErrors {
  display: none;
}
</style>
